export const LegacyCardDataHooks = {
  mediaContainer: 'legacyCardMediaContainer',
  infoContainer: 'legacyCardInfoContainer',
};
